module.exports = __webpack_public_path__ + "assets/3c433057f3de55dec0a7b2a4098fb8e9.mp3";